import { Method, RESPONSE_TYPE } from './utils/api-client-utils';
import ApiClientV2 from './utils/api-client-v2';

export const permissionsApiClientV2 = new ApiClientV2({
  microservice: 'permissions',
});

export const getTwoFactorAuthStatus = async id => {
  const response = await permissionsApiClientV2.makeRequest({
    path: '/api/v1/tenant/:tenantId/practice-users/:id/two-factor',
    method: Method.GET,
    headers: {
      'Content-Type': 'application/json',
    },
    replacements: { id },
  });

  return response;
};

export const updateTwoFactorAuth = async (id, twoFactorSettings) => {
  const payload = {
    twoStepVerificationEnabled: twoFactorSettings.twoStepVerificationEnabled,
    twoStepMethod: twoFactorSettings.twoStepMethod,
    twoStepPhoneNumber: twoFactorSettings.twoStepPhoneNumber,
  };

  const response = await permissionsApiClientV2.makeRequest({
    path: '/api/v1/tenant/:tenantId/practice-users/:id/two-factor',
    method: Method.PUT,
    body: JSON.stringify(payload),
    headers: {
      'Content-Type': 'application/json',
    },
    responseType: RESPONSE_TYPE.RAW,
    replacements: { id },
    updateNotificationDetails: { user: { id } },
  });

  return response;
};

export const deleteTwoFactorAuth = async id => {
  const response = await permissionsApiClientV2.makeRequest({
    path: '/api/v1/tenants/:tenantId/practice-users/:id/two-factor',
    method: Method.DELETE,
    headers: {
      'Content-Type': 'application/json',
    },
    responseType: RESPONSE_TYPE.RAW,
    replacements: { id },
    updateNotificationDetails: { user: { id } },
  });

  return response;
};
